import React, { Component, PureComponent } from 'react';
import { routerShape } from 'react-router';
import LazyHydrate from 'react-lazy-hydration';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import map from 'lodash/map';
import findIndex from 'lodash/findIndex';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import preload from 'api/data-preload';
import pageCache from 'api/page-cache';
import DataProvider from 'api/data-provider';
import Dict from 'api/data-dict';
import { simpleCheck } from 'api/data-check';
import seoPreload, { seoDecorator } from 'api/seo';
import GeoLandings from 'subsys/geo-landings';
import { FavoriteWrapper } from 'subsys/favorites';
import contentBlock, { blockPreloader } from 'containers/content-block';
import Link from 'components/link';
import sensor from 'components/sensor';
import Row, { Col } from 'components/row';
import { SeoText } from 'components/layouts';
import Breadcrumbs from 'components/breadcrumbs';
import { OpenGraphImage } from 'components/image';
import Paginator, { Control, Container, Pages } from 'components/paginator';

import linksDomik from 'src-sites/domik/links';
import blockConfig from 'src-sites/domik/blocks/config';
import BlockWrapper from 'src-sites/domik/blocks/block-wrapper';

import ListArticle from './article-list';
import { SearchInput, renderRubricsList } from './render-common';

import translates from './articles-i18n';

import 'styles/domik/section-articles/_articles-search.scss';
import 'styles/domik/section-articles/_rubrics-list.scss';
import 'styles/domik/section-articles/_page-articles.scss';

const bemClasses = new Bem('articles');
const bemClassesSearch = new Bem('articlesSearch');
const classesBemRubricsList = new Bem('rubricsList');

const NEWS_PER_PAGE = 25;

@preload((routeProps) => {
  const { params, location } = routeProps;
  const { landing } = params;
  const searchQuery = get(location, 'query.search');

  const order = searchQuery ?
    [['timeToPublishTrunc', 'desc'], ['textSearchRank', 'desc']] :
    [['pageList', 'desc'], ['standart', 'desc']];

  const query = {
    rubricId: searchQuery ? null : landing.entity_id,
    limit: NEWS_PER_PAGE,
    order,
    count: true
  }
  if (params.page) query.offset = (params.page - 1) * NEWS_PER_PAGE;

  let checkNeeded = true;
  if (searchQuery) {
    query.search = searchQuery;
    checkNeeded = false;
  }

  let otherConfig = {};
  if (checkNeeded) {
    otherConfig = {
      ...otherConfig,
      ...simpleCheck(['publications'])
    }
  }

  return {
    ...blockPreloader({
      project: 'domik',
      entity: 'newsListPage'
    }, blockConfig, []),
    rubric: [Dict.preload, { url: 'domik/publications/news-rubrics' }],
    rubricTree: [Dict.preload, { url: 'domik/publications/news-rubrics-tree' }],
    publications: [DataProvider.preload, {
      url: 'domik/news/publication-list',
      cache: searchQuery ? null : 5,
      query,
      queryJson: true
    }],
    ...seoPreload({
      entity: 'publRubric'
    }, ['rubric']),
    ...otherConfig,
    ...pageCache('publications')
  };
})
@seoDecorator({
  advancedVars: {
    bottomText: 'Текст в самом низу'
  }
})
@sensor
@I18nHoc(translates())
export default class PageList extends Component {
  static propTypes = {
    className: PropTypes.string,
    seoData: PropTypes.shape({}),
    publications: PropTypes.shape({}),
    nbStocksList: PropTypes.shape({}),
    rubric: PropTypes.shape({}),
    router: routerShape,
    params: PropTypes.shape({})
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.project = 'domik';

    this.onHandleResize = this.onHandleResize.bind(this);
    this.onResize = this.onHandleResize;

    this.state = {
      device: 'desktop',
      mounted: false
    };
  }

  componentDidMount() {
    this.onHandleResize(this.sensor.getRuntime());
    this.setState({ mounted: true });
  }

  componentDidUpdate(prevProps) {
    if(get(this,'props.params.url') !== get(prevProps,'params.url') && this.ddRef) {
      this.ddRef.getInstance().close();
    }
  }

  onHandleResize({ media: { desktop, tablet, phone } = {} }) {
    const { device } = this.state;

    if (desktop && device !== 'desktop') return this.setState({ device: 'desktop' });
    if (tablet && device !== 'tablet') return this.setState({ device: 'tablet' });
    if (phone && device !== 'phone') return this.setState({ device: 'phone' });
  }

  handleSearch = (val) => {
    const { router, location: { pathname } } = this.props;
    router.push({ pathname, query: { search: val } });
  }

  afterItemsContent = () => [
    this.renderSearchContentBlock('blockPArticles6'),
    this.renderSearchContentBlock('blockPArticles8'),
    this.renderSearchContentBlock('blockPArticles14'),
    this.renderSearchContentBlock('blockPArticles24')
  ];

  renderSearchContentBlock(name) {
    return contentBlock(
      blockConfig,
      name,
      this.props,
      { classNameWrapper: name, gtmProps: { 'place': 'Actions-Body' } }
    );
  }

  render() {
    const { i18n } = this;
    const {
      className, seoData, params: { page, landing } = {}, publications = {}, rubric = {},
      rubricTree = {}, location: { query }, mainMenuBase
    } = this.props;
    const seoText = get(seoData, 'bottomText');
    const rubricId = get(landing, 'params.rubricId');
    let rubricIndex = findIndex(rubric.data, it => it.id === rubricId);
    const name = get(rubric, `data[${rubricIndex}].name`);
    const name_short = get(rubric, `data[${rubricIndex}].name_short`);
    const rubricParent = +get(rubric, `data[${rubricIndex}].parent`);
    const subRubricId = rubricParent > 1 ? rubricParent : rubricId;
    const rubricTreeIndex = findIndex(rubricTree.data, it => it.id === subRubricId);
    const rubricTreeChildren = get(rubricTree, `data[${rubricTreeIndex}].children`, []);
    const header = get(seoData, 'header') ? seoData.header : name;
    const headerDescription = get(seoData, 'description') ? seoData.description : name_short;
    const searchQuery = get(query, 'search');
    const dataBreadcrumbs = [
      {
        name: i18n('breadcrumbsMain'),
        builder: linksDomik.sectionDomik,
        builderProps: { title: i18n('breadcrumbsMain') }
      },
      ...landing.breadcrumbs
    ];

    if (searchQuery) dataBreadcrumbs.push({
      name: searchQuery,
      builder: linksDomik.sectionDomik
    });

    return (
      <main {...bemClasses({ extra: className })}>
        <LazyHydrate ssrOnly>
          <OpenGraphImage />
        </LazyHydrate>
        <Breadcrumbs {...bemClasses('breadcrumbs', 'top')} data={dataBreadcrumbs} noJson />
        <Row {...bemClasses('row', 'main')}>
          <Col {...bemClasses('col', 'list')} allFlex allColumn allPr={0}>
            <div {...bemClasses('title')}>
              <div {...bemClasses('text')}><h1 children={searchQuery ? i18n('searchPlaceholder') : header} /></div>
            </div>
            {headerDescription &&
              <div {...bemClasses('description')}>
                <span {...bemClasses('text')}><p children={headerDescription} /></span>
              </div>
            }
            {!!rubricTreeChildren.length &&
              <div {...bemClasses('filters')}>
                {map(rubricTreeChildren, (item, key) => {
                  return (
                    <Link
                      {...bemClasses('link', 'filter')}
                      key={key}
                      builder={linksDomik.sectionLanding}
                      builderProps={{ title: item.name, url: item.url }}
                    >
                      <span {...bemClasses('linkContent')}>
                        <span {...bemClasses('text')} children={item.name} />
                      </span>
                    </Link>
                  );
                })}
              </div>
            }
            <FavoriteWrapper project={this.project} entity="publication">
              {({ data = {} }) => (
                <Paginator
                  url="domik/news/publication-list"
                  preloaded={publications}
                  preloadedStatic
                  limit={NEWS_PER_PAGE}
                  page={page}
                  changeUrl
                >
                  <Control />
                  <Container
                    {...bemClasses('list')}
                    injectPropName="data"
                    afterItemsContent={this.afterItemsContent}
                  >
                    <ListArticle
                      dataMods="list"
                      rubric={rubric}
                      favData={data}
                    />
                  </Container>
                  <Pages
                    {...bemClasses('pages')}
                    linkBuilder={linksDomik.sectionLanding}
                    linkBuilderProps={{
                      url: landing.url,
                      query: searchQuery ? { search: searchQuery } : null
                    }}
                    withArrows
                  />
                </Paginator>
              )}
            </FavoriteWrapper>
            <LazyHydrate whenVisible>
              {contentBlock(blockConfig, 'bottom1', this.props, { classNameWrapper: 'blockPArticlesBottom1', gtmProps: { 'place': 'Actions' } })}
              {contentBlock(blockConfig, 'bottom2', this.props, { classNameWrapper: 'blockPArticlesBottom2', gtmProps: { 'place': 'Actions' } })}
              {contentBlock(blockConfig, 'bottom3', this.props, { classNameWrapper: 'blockPArticlesBottom3', gtmProps: { 'place': 'Actions' } })}
            </LazyHydrate>
          </Col>
          <Col {...bemClasses('col', 'aside')} allFlex mdColumn allAuto allPr={0}>
            <aside {...bemClasses('aside')}>
              {/*{searchInput.call(this, { onSearch: this.handleSearch, value: searchQuery, i18n })}*/}
              <SearchInput
                {...bemClasses('search')}
                classes={bemClassesSearch}
                i18n={i18n}
                onSearch={this.handleSearch}
                value={searchQuery}
              />
              {renderRubricsList.call(this, classesBemRubricsList)}
              <GeoLandings base={mainMenuBase} injectPropName="landingLinks" project="domik">
                <GeoLandingsWrapper {...this.props} />
              </GeoLandings>
            </aside>
          </Col>
        </Row>
        <Breadcrumbs {...bemClasses('breadcrumbs')} data={dataBreadcrumbs} />
        <SeoText data={seoText} />
      </main>
    );
  }
}

class GeoLandingsWrapper extends PureComponent {
  static propTypes = {
    landingLinks: PropTypes.shape({}),
    geolocation: PropTypes.shape({})
  };

  render() {
    const { landingLinks, geolocation } = this.props;

    return (
      <>
        {contentBlock(blockConfig, 'rightColumn1', this.props, { geolocation, landingLinks, wrapper: BlockWrapper, withContainer: false })}
        {contentBlock(blockConfig, 'rightColumn2', this.props, { geolocation, landingLinks, wrapper: BlockWrapper, withContainer: false })}
        {contentBlock(blockConfig, 'rightColumn3', this.props, { geolocation, landingLinks, wrapper: BlockWrapper, withContainer: false })}
        {contentBlock(blockConfig, 'rightColumn4', this.props, { geolocation, landingLinks, wrapper: BlockWrapper, withContainer: false })}
        {contentBlock(blockConfig, 'rightColumn5', this.props, { geolocation, landingLinks, wrapper: BlockWrapper, withContainer: false })}
      </>
    );
  }
}
